import { render, staticRenderFns } from "./ListCommunications.vue?vue&type=template&id=375963ac"
import script from "./ListCommunications.vue?vue&type=script&lang=ts"
export * from "./ListCommunications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports